module.exports = __webpack_public_path__ + "img/bg_mid.232e233e.png";